import React from 'react'
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { FaDownload } from 'react-icons/fa6'
import { Button } from 'components';

const Export = ({ fileData, fileName }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToExcel = async () => {
        const ws = XLSX.utils.json_to_sheet(fileData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'], };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };
    return (
        <Button
            icon={<FaDownload />} 
            onClick={exportToExcel}
        >
            Татах
        </Button>
    )
}

export default Export